import _objectWithoutProperties from "/Users/mleroux/Web/landing/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import * as e from "react";
export function createContext(t) {
  var r = /*#__PURE__*/e.createContext(null);

  function n(t) {
    var n = t.children,
        o = _objectWithoutProperties(t, _excluded),
        u = e.useMemo(function () {
      return o;
    }, Object.values(o));
    /*#__PURE__*/


    return e.createElement(r.Provider, {
      value: u
    }, n);
  }

  return n.displayName = t + "Provider", [n, function (n) {
    var o = e.useContext(r);
    if (null === o) throw new Error("`".concat(n, "` must be used within `").concat(t, "`"));
    return o;
  }];
}